import { Component } from '@angular/core'
import { AutomationEventTypes, AutomationHandler, AutomationTypes } from '@tokeet-frontend/automations'
import { FormBuilder } from '@angular/forms'
import {
  guestChargeNotificationMessages,
  userChargeNotificationMessages,
} from '@tv3/containers/automations/automations-wizard/charge/messages'
import { Store } from '@ngrx/store'
import { AutomationWizardPanelBaseComponent } from '@tv3/containers/automations/automations-wizard/automation-wizard-panel.component'
import { Actions } from '@ngrx/effects'

@Component({
  selector: 'app-charge-automation-wizard',
  templateUrl: './charge-automation-wizard.component.html',
  styleUrls: ['./charge-automation-wizard.component.scss'],
})
export class ChargeAutomationWizardComponent extends AutomationWizardPanelBaseComponent {
  type = AutomationTypes.Charge
  guestNotificationMessages = guestChargeNotificationMessages
  userNotificationMessages = userChargeNotificationMessages

  constructor(protected fb: FormBuilder, protected actions: Actions, protected store: Store<any>) {
    super(actions, store, fb)

    this.form.patchValue({ event: AutomationEventTypes.ChargeCreated })
  }
}
